import uuid from 'uuid/v4';
import moment from 'moment';
import _, { cloneDeep, isEmpty } from 'lodash';
import * as types from '../actions/actionTypes';
import * as CrosstabUtils from '../util/CrosstabUtils';
import { roundWeighted } from '../util/CommonUtils';
import initialState from './initialState';
import { FLEX_STUDY_TAG, PROBABILTIES_FUNCTIONS } from '../constants';

export default (state = initialState.crosstab, action) => {
  switch (action.type) {
    case types.REMOVE_CROSSTAB_DATA: {
      return { ...state, [action.crosstabKey]: undefined };
    }

    case types.ADD_DD_NHCS_CROSSTAB_REPORT: {
      return { ...state, ddNHCSReportsList: action.payload };
    }

    case types.CLEAR_CROSSTAB_SAMPLE_WEIGHTED: {
      const keyType = `${action.targetGrid}Data`;
      const recycleElements = state.RecycleGridData
        ? [...state.RecycleGridData]
        : [];
      const titleHeaderList = cloneDeep(state.crosstabTitleHeaderList);
      const selectedGridData = state[keyType] ? [...state[keyType]] : [];
      if (titleHeaderList && titleHeaderList[action.targetGrid]) {
        titleHeaderList[action.targetGrid] = [];
      }
      return {
        ...state,
        [keyType]: [],
        RecycleGridData: [...selectedGridData, ...recycleElements],
        crosstabTitleHeaderList: titleHeaderList,
      };
    }

    case types.UPDATE_CROSSTAB_SAMPLE_WEIGHTED: {
      const keyType = `${action.targetGrid}Data`;
      const keywordArr = [];
      const gridData = [];
      const titleArr = [];
      action.gridData.forEach(elems => {
        if (
          keywordArr.indexOf(elems.keyword.trim()) === -1 ||
          titleArr.indexOf(elems.title.trim()) === -1
        ) {
          keywordArr.push(elems.keyword.trim());
          titleArr.push(elems.title.trim());
          gridData.push(elems);
        }
      });
      return {
        ...state,
        [keyType]: [...gridData],
      };
    }

    case types.GET_CROSSTAB_SAMPLE_WEIGHTED: {
      // Required Parameters: payload, targetGrid, expressionList, selectedNames
      // Optional Parameters: sourceGrid, gridData, titlePrefix, originalNames
      const keyType = `${action.targetGrid}Data`;
      // const crosstabTableList = cloneDeep(state.crosstabTableList);
      let gridData = [];
      const userDefinedText = action.userDefinedText;
      const oldProductNo = action.oldProductNo && action.oldProductNo;
      if (
        action.gridData ||
        (oldProductNo && oldProductNo !== action.productNo)
      ) {
        gridData = action.gridData ? action.gridData : [];
      } else if (state[keyType]) {
        gridData = state[keyType];
      }
      const titlePrefix = action.titlePrefix ? action.titlePrefix : '';
      const selectedKPIsTitle = { ...state.selectedKPIsTitle };

      const savedKPIs = { ...state.allSelectedKPIsInfo };
      const sampleWeightedKPIs = { ...state.sampleWeightedKPIs };
      action.expressionList.forEach((item, index) => {
        savedKPIs[item] = {
          modeled: action.payload[index]
            ? action.payload[index].modeled
            : false,
          productNo: action.productNo,
        };
        sampleWeightedKPIs[item] = {
          productNo: action.productNo,
          data: action.payload[index] ? [action.payload[index]] : [],
        };
      });
      const keywordArr = gridData.map(elems => {
        return elems.keyword.trim();
      });
      const titleArr = gridData.map(elems => {
        return elems.title.trim().toUpperCase();
      });
      const draggedItems = [];
      action.payload.forEach((selectedEntry, index) => {
        let title = '';
        const isLabelUpdated = action.isLabelUpdated
          ? action.isLabelUpdated[index]
          : undefined;
        if (
          action.sourceGrid !== 'FunctionBox' &&
          action.targetGrid !== 'FunctionBoxCountDataGrid'
        ) {
          title = `${titlePrefix.toUpperCase()}${action.selectedNames[
            index
          ].toUpperCase()}`;
        }
        if (action.targetGrid === 'FunctionBoxCountDataGrid') {
          title = titlePrefix
            ? `${titlePrefix.toUpperCase()}${action.selectedNames[
                index
              ].toUpperCase()}`
            : '';
        }
        if (action.sourceGrid === 'FunctionBox') {
          title = action.selectedNames[index].toUpperCase();
        }
        let originalTitle = title;
        const rectype = action.recTypes && action.recTypes[index];
        selectedKPIsTitle[action.expressionList[index]] = title;
        if (action.originalNames && action.originalNames.length > 0) {
          originalTitle = action.originalNames[index];
        } else if (
          action.sourceGrid !== 'ColumnsDataGrid' &&
          action.sourceGrid !== 'RowsDataGrid' &&
          action.sourceGrid !== 'BasesDataGrid' &&
          action.sourceGrid !== 'ScratchDataGrid' &&
          action.sourceGrid !== 'ExpressionCodingBox' &&
          action.sourceGrid !== 'StandardBasesDataGrid' &&
          action.sourceGrid !== 'FunctionBox' &&
          action.sourceGrid !== 'AutocodeSelectionBox'
        ) {
          originalTitle = CrosstabUtils.DEFAULT_GRID_CELL_LABEL;
        }
        const weighted =
          selectedEntry && selectedEntry.weighted
            ? roundWeighted(selectedEntry.weighted)
            : '';
        const updatedWeighted =
          action.targetGrid === 'FunctionBoxCommonDataGrid' ||
          action.targetGrid === 'FunctionBoxCountDataGrid'
            ? CrosstabUtils.smartRoundOff(weighted * 1000)
            : roundWeighted(weighted);

        if (keyType === 'StandardBasesDataGridData') {
          draggedItems.push({
            id: uuid(),
            sample:
              selectedEntry && selectedEntry.intab ? selectedEntry.intab : '',
            keyword: action.expressionList[index],
            weighted: updatedWeighted === 0 ? '' : updatedWeighted,
            title,
            originalTitle,
            rectype,
            dataSmartSearch: action.objSmartSearchArray
              ? action.objSmartSearchArray[index]
              : undefined,
          });
        } else if (
          keywordArr.indexOf(action.expressionList[index].trim()) === -1 ||
          titleArr.indexOf(title.trim()) === -1 ||
          action.weightChange
        ) {
          let dataSmartSearch = [];
          if (
            action.sourceGrid === 'ColumnsDataGrid' &&
            !(action.objSmartSearchArray && action.objSmartSearchArray[index])
          ) {
            dataSmartSearch = CrosstabUtils.createDataSmartSearch(
              state.CrosstabBreadCrumbsList,
              state.DictionaryDetails,
              action.expressionList[index],
              originalTitle,
              'ColumnsGrid'
            );
          } else if (
            action.sourceGrid === 'RowsDataGrid' &&
            !(action.objSmartSearchArray && action.objSmartSearchArray[index])
          ) {
            dataSmartSearch = CrosstabUtils.createDataSmartSearch(
              state.CrosstabBreadCrumbsList,
              state.DictionaryDetails,
              action.expressionList[index],
              originalTitle,
              'RowsGrid'
            );
          }
          draggedItems.push({
            id: uuid(),
            sample:
              selectedEntry && selectedEntry.intab ? selectedEntry.intab : '',
            keyword: action.expressionList[index],
            weighted: updatedWeighted === 0 ? '' : updatedWeighted,
            title,
            originalTitle,
            rectype,
            userDefinedText,
            dataSmartSearch:
              action.objSmartSearchArray && action.objSmartSearchArray[index]
                ? action.objSmartSearchArray[index]
                : dataSmartSearch,
            isLabelUpdated,
          });
        }
      });
      let finalData = [];
      if (keyType === 'StandardBasesDataGridData' || action.weightChange) {
        finalData = [...draggedItems];
      } else {
        finalData = [...gridData, ...draggedItems];
      }
      return {
        ...state,
        selectedKPIsTitle,
        [keyType]: finalData,
        allSelectedKPIsInfo: savedKPIs,
        sampleWeightedKPIs,
      };
    }

    case types.GET_CROSSTAB_SAMPLE_WEIGHTED_DATA: {
      const keyType = `${action.targetGrid}Data`;
      const gridData = action.gridData ? action.gridData : [];
      const titlePrefix = action.titlePrefix ? action.titlePrefix : '';
      const selectedKPIsTitle = { ...state.selectedKPIsTitle };

      const savedKPIs = { ...state.allSelectedKPIsInfo };
      const sampleWeightedKPIs = { ...state.sampleWeightedKPIs };

      action.expressionList.forEach((item, index) => {
        savedKPIs[item] = {
          modeled: action.payload[index]
            ? action.payload[index].modeled
            : false,
          productNo: action.productNo,
        };
        sampleWeightedKPIs[item] = {
          productNo: action.productNo,
          data: action.payload[index] ? [action.payload[index]] : [],
        };
      });
      const keywordArr = gridData.map(elems => {
        return elems.keyword;
      });
      const titleArr = gridData.map(elems => {
        return elems.title.trim().toUpperCase();
      });
      const draggedItems = [];
      action.payload.forEach((selectedEntry, index) => {
        const title = `${titlePrefix.toUpperCase()}${action.selectedNames[
          index
        ].toUpperCase()}`;
        let originalTitle = title;
        const isLabelUpdated = action.isLabelUpdated
          ? action.isLabelUpdated[index]
          : undefined;
        selectedKPIsTitle[action.expressionList[index]] = title;
        const rectype = action.recTypes && action.recTypes[index];
        if (action.originalNames && action.originalNames.length > 0) {
          originalTitle = action.originalNames[index];
        } else if (
          action.sourceGrid !== 'ColumnsDataGrid' &&
          action.sourceGrid !== 'RowsDataGrid' &&
          action.sourceGrid !== 'BasesDataGrid' &&
          action.sourceGrid !== 'ScratchDataGrid' &&
          action.sourceGrid !== 'ExpressionCodingBox' &&
          action.sourceGrid !== 'AutocodeSelectionBox'
        ) {
          originalTitle = CrosstabUtils.DEFAULT_GRID_CELL_LABEL;
        }
        const weighted =
          selectedEntry && selectedEntry.weighted
            ? roundWeighted(selectedEntry.weighted)
            : '';
        const updatedWeighted =
          action.targetGrid === 'FunctionBoxCommonDataGrid' ||
          action.targetGrid === 'FunctionBoxCountDataGrid'
            ? CrosstabUtils.smartRoundOff(weighted * 1000)
            : roundWeighted(weighted);
        if (
          keywordArr.indexOf(action.expressionList[index]) === -1 ||
          titleArr.indexOf(title.trim()) === -1
        ) {
          draggedItems.push({
            id: uuid(),
            sample:
              selectedEntry && selectedEntry.intab ? selectedEntry.intab : '',
            keyword: action.expressionList[index],
            weighted: updatedWeighted === 0 ? '' : updatedWeighted,
            title,
            originalTitle,
            rectype,
            dataSmartSearch: action.objSmartSearchArray
              ? action.objSmartSearchArray[index]
              : undefined,
            isLabelUpdated,
          });
        }
      });
      return {
        ...state,
        selectedKPIsTitle,
        [keyType]: [...gridData, ...draggedItems],
        allSelectedKPIsInfo: savedKPIs,
        sampleWeightedKPIs,
      };
    }

    case types.SELECT_CROSSTAB_GRID: {
      const crosstabTableList = state.crosstabTableList
        ? state.crosstabTableList
        : [];
      return {
        ...state,
        crosstabTableList: [
          ...crosstabTableList.map(crosstabTable => ({
            ...crosstabTable,
            isActive: crosstabTable.idKey === action.idKey,
          })),
        ],
      };
    }

    case types.DELETE_CROSSTAB_GRID: {
      return {
        ...state,
        loadedCrosstabInfo: {
          id: undefined,
          title: undefined,
          tableTitle: '',
          isDuplicateCrossTabTitle: false,
        },
        crosstabTableList: undefined,
        isTitleUpdated: true,
        activeCrosstabTable: {},
        crosstabTitleHeaderList: {},
      };
    }

    case types.TOGGLE_CROSSTAB_GRID_DATA: {
      const keyType = `${action.targetGrid}Data`;
      return {
        ...state,
        crosstabTableList: [...action.updatedCrosstabTableList],
        [keyType]: [...action.updatedGridData],
        crosstabRequestData: action.updatedCrosstabRequestData,
        crosstabPayload: action.updatedCrosstabPayload,
      };
    }

    case types.UPDATE_CROSSTAB_GRID: {
      const crosstabTableList = state.crosstabTableList
        ? state.crosstabTableList
        : [];
      return {
        ...state,
        crosstabTableList: crosstabTableList.map(crosstabTable => {
          if (crosstabTable.idKey === action.idKey) {
            return {
              ...crosstabTable,
              ...action.updatedData,
            };
          }

          return { ...crosstabTable };
        }),
      };
    }

    case types.UPDATE_CROSSTAB_ID: {
      const crosstabTableList = state.crosstabTableList
        ? state.crosstabTableList
        : [];
      return {
        ...state,
        crosstabTableList: crosstabTableList.map(crosstabTable => {
          if (crosstabTable.idKey === action.idKey) {
            return {
              ...crosstabTable,
              id: action.payload.newId,
            };
          }
          return { ...crosstabTable };
        }),
        isTitleUpdated: false,
      };
    }

    case types.UPDATE_SAVED_CROSSTAB_INFO: {
      const crosstabID =
        action.payload && action.payload.newId
          ? action.payload.newId
          : action.crosstabId;
      const crosstabTableList = state.crosstabTableList
        ? state.crosstabTableList
        : [];
      return {
        ...state,
        loadedCrosstabInfo: {
          id: crosstabID,
          title: action.title,
          tableTitle: action.tableTitle,
          isDuplicateCrossTabTitle: action.updateLoadedCrosstab,
        },
        crosstabTableList: crosstabTableList.map(crosstabTable => {
          if (crosstabTable.idKey === action.idKey) {
            return {
              ...crosstabTable,
              id: crosstabID,
              title: action.title,
            };
          }
          if (action.resetTable) {
            return {
              ...crosstabTable,
              id: undefined,
              title: undefined,
            };
          }

          return { ...crosstabTable };
        }),
        isTitleUpdated: true,
      };
    }

    case types.SHOW_CROSSTAB_GRID: {
      // const crosstabTableList = state.crosstabTableList
      // ? state.crosstabTableList : []; #commented for Beta
      const {
        payload,
        crosstabTitle,
        studyDescriptions,
        colOriginalHeaderList,
        rowOriginalHeaderList,
        baseOriginalHeaderList,
        colExpressionList,
        rowExpressionList,
        baseList,
        colHeaderList,
        rowHeaderList,
        baseHeaderList,
        studyInfo,
        baseIDList,
        runType,
        highlightAndFilter,
        conditionalFormatting,
        selectedBaseNode,
        selectedBaseGroup,
        selectedBaseID,
        userDefinedBaseList,
        standardBaseList,
        accountId,
        crosstabColumns,
        crosstabRows,
        selectedStandardBaseFlag,
        requestData,
        selectedWeight,
      } = action;

      let originalBaseList;
      let crosstabPayload;
      let crosstabBaseList;
      if (selectedStandardBaseFlag) {
        crosstabPayload = cloneDeep(state.crosstabPayload);
        crosstabPayload.forEach((item, index) => {
          const newPayload = payload[index].crosstabList[1];
          crosstabPayload[index].crosstabList.push(newPayload);
        });

        crosstabBaseList = { ...state.crosstabBaseList };

        crosstabBaseList.baseIDList = [
          ...crosstabBaseList.baseIDList,
          ...baseIDList,
        ];
        crosstabBaseList.baseList = [...crosstabBaseList.baseList, ...baseList];
        crosstabBaseList.baseHeaderList = [
          ...crosstabBaseList.baseHeaderList,
          ...baseHeaderList,
        ];
        crosstabBaseList.baseOriginalHeaderList = [
          ...crosstabBaseList.baseOriginalHeaderList,
          ...baseOriginalHeaderList,
        ];

        if (studyInfo && !studyInfo.st.toLowerCase().includes(FLEX_STUDY_TAG)) {
          originalBaseList = [
            'STUDY UNIVERSE',
            ...crosstabBaseList.baseOriginalHeaderList,
          ];
        } else {
          originalBaseList = [...crosstabBaseList.baseOriginalHeaderList];
        }
      } else {
        crosstabBaseList = {};

        crosstabBaseList.baseIDList = [...baseIDList];
        crosstabBaseList.baseList = [...baseList];
        crosstabBaseList.baseHeaderList = [...baseHeaderList];
        crosstabBaseList.baseOriginalHeaderList = [...baseOriginalHeaderList];

        crosstabPayload = payload;

        if (studyInfo && !studyInfo.st.toLowerCase().includes(FLEX_STUDY_TAG)) {
          originalBaseList = ['STUDY UNIVERSE', ...baseOriginalHeaderList];
        } else {
          originalBaseList = [...baseOriginalHeaderList];
        }
      }

      const crosstabColumnsFootNote = cloneDeep(state.ColumnsDataGridData);
      crosstabColumnsFootNote.map((column, index) => {
        column.footnotes = crosstabPayload[0].headerFootNotes[index];
        return column;
      });

      // this has to be reviewed again - nikhil
      const crosstabRowsFootNote = cloneDeep(state.RowsDataGridData);
      const selectedBase =
        state.activeCrosstabTable.selectedBase &&
        state.activeCrosstabTable.selectedBase.selectedBase
          ? state.selectedBase.selectedBase
          : 0;
      crosstabRowsFootNote.map((row, index) => {
        row.footnotes =
          crosstabPayload[0].crosstabList[selectedBase] &&
          crosstabPayload[0].crosstabList[selectedBase].rowList[index + 1] &&
          crosstabPayload[0].crosstabList[selectedBase].rowList[index + 1]
            .footnotes
            ? crosstabPayload[0].crosstabList[selectedBase].rowList[index + 1]
                .footnotes
            : [];
        return row;
      });

      const crosstabBasesFootNote = cloneDeep(state.BasesDataGridData);
      crosstabBasesFootNote.map((row, index) => {
        row.footnotes =
          crosstabPayload[0].crosstabList[index + 1] &&
          crosstabPayload[0].crosstabList[index + 1].baseFootnotes
            ? crosstabPayload[0].crosstabList[index + 1].baseFootnotes
            : [];
        return row;
      });

      const crosstabDataParams = {
        crosstabData: [...crosstabPayload],
        colOriginalHeaderList: ['Total', ...colOriginalHeaderList],
        rowOriginalHeaderList: ['Total', ...rowOriginalHeaderList],
        baseOriginalHeaderList: [...originalBaseList],
        crosstabTitle,
        studyDescriptions,
        colExpressionList,
        rowExpressionList,
        baseList: crosstabBaseList.baseList,
        colHeaderList,
        rowHeaderList,
        baseHeaderList: crosstabBaseList.baseHeaderList,
        studyInfo,
        baseIDList: crosstabBaseList.baseIDList,
        id:
          state.loadedCrosstabInfo && state.loadedCrosstabInfo.id
            ? state.loadedCrosstabInfo.id
            : undefined,
        title: state.loadedCrosstabInfo.title,
        runType,
        highlightAndFilter,
        conditionalFormatting,
        crosstabTitleHeaderList: { ...state.crosstabTitleHeaderList },
        rowData:
          state.updatedTitleData && state.updatedTitleData.rowData
            ? state.updatedTitleData.rowData
            : [],
        colData:
          state.updatedTitleData && state.updatedTitleData.colData
            ? state.updatedTitleData.colData
            : [],
        userDefinedBasesPresent: state.BasesDataGridData.length > 0,
        selectedBaseNode,
        selectedBaseGroup,
        selectedBaseID,
        userDefinedBaseList,
        standardBaseList,
        accountId,
        crosstabColumns,
        crosstabRows,
      };
      const newCrosstabTable = CrosstabUtils.populateCrosstabData(
        crosstabDataParams
      );
      return {
        ...state,
        loadedCrosstabInfo: {
          ...state.loadedCrosstabInfo,
          tableTitle: state.loadedCrosstabInfo.title,
        },
        crosstabTableList: [newCrosstabTable],
        crosstabRequestData: requestData,
        isTitleUpdated: true,
        crosstabPayload: [...crosstabPayload],
        crosstabBaseList,
        crosstabSelectedWeight: selectedWeight,
        ColumnsDataGridData: crosstabColumnsFootNote,
        RowsDataGridData: crosstabRowsFootNote,
        BasesDataGridData: crosstabBasesFootNote,
        trendComplete: false,
      };
    }

    case types.SHOW_VALIDATE_RESPONSE: {
      if (action.trendMultipleProducts) {
        return {
          ...state,
          gridsValidationResponse: {
            trendProducts: [...action.payload],
            baseOriginalHeaderList: action.baseOriginalHeaderList,
            colOriginalHeaderList: action.colOriginalHeaderList,
            rowOriginalHeaderList: action.rowOriginalHeaderList,
            isColLabelUpdated: action.isColLabelUpdated,
            isRowLabelUpdated: action.isRowLabelUpdated,
          },
        };
      }
      return {
        ...state,
        gridsValidationResponse: {
          ...action.payload,
          baseOriginalHeaderList: action.baseOriginalHeaderList,
          colOriginalHeaderList: action.colOriginalHeaderList,
          rowOriginalHeaderList: action.rowOriginalHeaderList,
          oldProductNo: action.oldProductNo,
          isColLabelUpdated: action.isColLabelUpdated,
          isRowLabelUpdated: action.isRowLabelUpdated,
        },
      };
    }

    case types.LOAD_SAVED_CROSSTAB: {
      const payloadData = cloneDeep(action.payload);
      const isColLabelUpdated = [];
      const isRowLabelUpdated = [];

      const RowsDataGrid = [];
      const ColumnsDataGrid = [];

      if (action.importSPC) {
        const rowData = action.payload.titleRowList;
        const colData = action.payload.titleColList;
        if (rowData && rowData.length > 0) {
          rowData.forEach(item => {
            const newItem = item.split('||');
            RowsDataGrid.push({
              index: parseInt(newItem[0], 10),
              keyword: newItem[1],
              updatedTitle: newItem[2],
              originalTitle: newItem[3],
            });
          });
        }
        if (colData && colData.length > 0) {
          colData.forEach(item => {
            const newItem = item.split('||');
            ColumnsDataGrid.push({
              index: parseInt(newItem[0], 10),
              keyword: newItem[1],
              updatedTitle: newItem[2],
              originalTitle: newItem[3],
            });
          });
        }
        action.payload.colExpressionList.forEach(exp => {
          let flag = false;
          ColumnsDataGrid.map(item => {
            flag = flag || item.keyword === exp;
            return flag;
          });
          isColLabelUpdated.push(flag);
        });

        action.payload.rowExpressionList.forEach(exp => {
          let flag = false;
          RowsDataGrid.map(item => {
            flag = flag || item.keyword === exp;
            return flag;
          });
          isRowLabelUpdated.push(flag);
        });
      } else {
        const ColumnsDataGridData = action.payload.attributes
          ? action.payload.attributes.crosstabColumns
          : [];
        const RowsDataGridData = action.payload.attributes
          ? action.payload.attributes.crosstabRows
          : [];
        if (ColumnsDataGridData) {
          ColumnsDataGridData.forEach((elems, index) => {
            isColLabelUpdated.push(elems.isLabelUpdated);
            if (elems.isLabelUpdated) {
              ColumnsDataGrid.push({
                index,
                keyword: elems.keyword,
                updatedTitle: elems.title,
                originalTitle: elems.originalTitle,
              });
            }
          });
        }

        if (RowsDataGridData) {
          RowsDataGridData.forEach((elems, index) => {
            isRowLabelUpdated.push(elems.isLabelUpdated);
            if (elems.isLabelUpdated) {
              RowsDataGrid.push({
                index,
                keyword: elems.keyword,
                updatedTitle: elems.title,
                originalTitle: elems.originalTitle,
              });
            }
          });
        }
      }
      payloadData.isColLabelUpdated = isColLabelUpdated;
      payloadData.isRowLabelUpdated = isRowLabelUpdated;

      return {
        ...state,
        savedCrosstabData: payloadData,
        loadedCrosstabInfo: {
          id: action.payload.id,
          title: action.payload.title,
          tableTitle:
            state.crosstabTableList && state.crosstabTableList.length > 0
              ? state.loadedCrosstabInfo.tableTitle
              : action.payload.title,
          isDuplicateCrossTabTitle: false,
          chartType: action.payload.attributes
            ? action.payload.attributes.chartType
            : undefined,
        },
        crosstabTitleHeaderList: {
          RowsDataGrid,
          ColumnsDataGrid,
        },
        BasesDataGridData: [], // action.payload.attributes
        // ? action.payload.attributes.crosstabBases
        // : [],
        RowsDataGridData: [],
        ColumnsDataGridData: [],
      };
    }

    case types.FETCH_CROSSTAB_TRENDS_KPI: {
      const selectedTrendsKPIsInfo = { ...state.selectedTrendsKPIsInfo };
      const savedKPI = {};
      action.payload.expressionList.forEach((item, index) => {
        savedKPI[item] = {
          modeled: action.payload.response[index]
            ? action.payload.response[index].modeled
            : false,
          header: action.payload.headerList[item],
        };
      });
      selectedTrendsKPIsInfo[action.payload.productNo] = savedKPI;
      return {
        ...state,
        selectedTrendsKPIsInfo,
      };
    }

    case types.VALID_TREND_ROW_COL_BASES: {
      let BasesDataGridData = cloneDeep(state.BasesDataGridData);
      let ColumnsDataGridData = cloneDeep(state.ColumnsDataGridData);
      let RowsDataGridData = cloneDeep(state.RowsDataGridData);
      action.payload.forEach(data => {
        if (data.grid === 'Columns') {
          ColumnsDataGridData = ColumnsDataGridData.filter(e => {
            return !data.invalidList.some(
              item => item.expression === e.keyword
            );
          });
        } else if (data.grid === 'Rows') {
          RowsDataGridData = RowsDataGridData.filter(e => {
            return !data.invalidList.some(
              item => item.expression === e.keyword
            );
          });
        } else if (data.grid === 'Bases') {
          BasesDataGridData = BasesDataGridData.filter(e => {
            return !data.invalidList.some(
              item => item.expression === e.keyword
            );
          });
        }
      });

      return {
        ...state,
        BasesDataGridData,
        crosstabBaseList: BasesDataGridData,
        ColumnsDataGridData,
        RowsDataGridData,
        trendComplete: true,
      };
    }

    case types.DELETE_SAVED_CROSSTAB: {
      const finalSavedCrosstabs = state.savedCrosstabs.filter(
        savedCrosstab => savedCrosstab.id !== action.payload
      );
      return {
        ...state,
        savedCrosstabs: finalSavedCrosstabs,
        loadedCrosstabInfo:
          state.loadedCrosstabInfo.id === action.payload
            ? {
                id: '',
                title: '',
                tableTitle: '',
                isDuplicateCrossTabTitle: false,
              }
            : state.loadedCrosstabInfo,
      };
    }

    case types.SHOW_SAVED_CROSSTABS: {
      const crosstabList = action.payload.map(entry => ({
        id: entry.spcxId,
        title: entry.title,
        lastModified: moment(entry.lastModified).format('MM/D/YYYY hh:mm A'),
        lastModifiedSortable: entry.lastModified,
      }));
      return { ...state, savedCrosstabs: crosstabList };
    }

    case types.EXPORT_CROSSTAB: {
      const link = document.createElement('a');
      document.body.appendChild(link);
      if (action.payload.url) {
        link.href = action.payload.url;
      } else {
        link.href = '#';
      }
      link.click();
      return state;
    }
    case types.FETCH_SAMPLE_CROSSTAB_KPI: {
      return {
        ...state,
        kpiInfo: {
          ...action.payload[0],
          expressionList: action.payload.expressionList[0],
        },
      };
    }

    case types.FETCH_STANDARD_BASE_LIST: {
      if (action.payload.length > 0) {
        return {
          ...state,
          standardBaseLists: action.payload,
        };
      }
      return {
        ...state,
        standardBaseLists: action.payload,
        StandardBasesDataGridData: action.payload,
      };
    }

    case types.EXPORT_BASE_SELCTION_LIST: {
      return {
        ...state,
        exportBaseSelectionList: {
          ...state.exportBaseSelectionList,
          itemsLeft: action.payload.itemsLeft,
          itemsRight: action.payload.itemsRight,
          universalStudy: action.payload.universalStudy,
        },
      };
    }

    case types.FETCH_CROSSTAB_KPI: {
      const savedKPIs = { ...state.allSelectedKPIsInfo };
      const sampleWeightedKPIs = { ...state.sampleWeightedKPIs };
      const selectedKPIsTitle = { ...state.selectedKPIsTitle };
      const kpiExpression = action.payload.kpiExpression || {};

      for (const key in kpiExpression) {
        selectedKPIsTitle[key] = kpiExpression[key];
      }

      action.payload.expressionList.forEach((item, index) => {
        savedKPIs[item] = {
          modeled: action.payload.response[index]
            ? action.payload.response[index].modeled
            : false,
          productNo: action.payload.productNo,
        };
        sampleWeightedKPIs[item] = {
          productNo: action.payload.productNo,
          data: action.payload[index] ? [action.payload[index]] : [],
        };
      });
      return {
        ...state,
        allSelectedKPIsInfo: savedKPIs,
        kpiInfo: {
          ...action.payload[0],
          expressionList: action.payload.expressionList[0],
        },
        sampleWeightedKPIs,
        selectedKPIsTitle,
      };
    }

    case types.CLEAR_SAMPLE_WEIGHTED_CROSSTAB_KPI: {
      return {
        ...state,
        sampleWeightedKPIs: {},
      };
    }

    case types.REMOVE_CROSSTAB_KPI: {
      return {
        ...state,
        kpiInfo: undefined,
      };
    }
    case types.SET_ACTIVE_CROSSTAB_TABLE: {
      return {
        ...state,
        activeCrosstabTable: action.activeCrosstabTable,
      };
    }
    case types.UPDATE_CROSSTAB_TITLE_HEADER: {
      const crosstabTitleHeaderList = { ...state.crosstabTitleHeaderList };

      const updatedHeader = crosstabTitleHeaderList[action.payload.gridCategory]
        ? cloneDeep(crosstabTitleHeaderList[action.payload.gridCategory])
        : [];
      if (updatedHeader.length > 0) {
        const matchedItem = updatedHeader.filter(
          item => item.keyword === action.payload.keyword
        );
        if (matchedItem.length > 0) {
          const indexToDelete = updatedHeader.findIndex(
            item => item.keyword === matchedItem[0].keyword
          );
          if (indexToDelete !== -1) {
            if (
              action.payload.updatedTitle !==
              updatedHeader[indexToDelete].originalTitle
            ) {
              updatedHeader.splice(indexToDelete, 1);
              updatedHeader.push({
                index: action.payload.index,
                originalTitle: action.payload.originalTitle,
                updatedTitle: action.payload.updatedTitle,
                keyword: action.payload.keyword,
              });
            } else {
              updatedHeader.splice(indexToDelete, 1);
            }
          }
        } else {
          updatedHeader.push({
            index: action.payload.index,
            originalTitle: action.payload.originalTitle,
            updatedTitle: action.payload.updatedTitle,
            keyword: action.payload.keyword,
          });
        }
      } else {
        updatedHeader.push({
          index: action.payload.index,
          originalTitle: action.payload.originalTitle,
          updatedTitle: action.payload.updatedTitle,
          keyword: action.payload.keyword,
        });
      }
      crosstabTitleHeaderList[action.payload.gridCategory] = updatedHeader;

      return {
        ...state,
        crosstabTitleHeaderList,
      };
    }

    case types.UPDATE_CROSSTAB_TITLE_LIST: {
      const titleHeaderListData = cloneDeep(state.crosstabTitleHeaderList);
      if (
        !isEmpty(titleHeaderListData) &&
        titleHeaderListData[action.targetGrid]
      ) {
        const selectedGridData = titleHeaderListData[action.targetGrid];
        const index = selectedGridData.findIndex(
          item => item.index === action.deletedIndex
        );
        if (index !== -1) {
          selectedGridData.splice(index, 1);
        }
        titleHeaderListData[action.targetGrid] = selectedGridData;
      }
      return {
        ...state,
        crosstabTitleHeaderList: titleHeaderListData,
      };
    }

    case types.UPDATE_RENAMED_GRID_INDEX: {
      const titleHeaderListData = cloneDeep(state.crosstabTitleHeaderList);
      if (
        !isEmpty(titleHeaderListData) &&
        titleHeaderListData[action.targetGrid]
      ) {
        const selectedGridData = titleHeaderListData[action.targetGrid];
        const updatedSelectedGridData = [];
        selectedGridData.forEach(item => {
          const currentIndex = item.index;
          if (action.deletedObj[currentIndex] !== undefined) {
            item.index = action.deletedObj[currentIndex];
            updatedSelectedGridData.push(item);
          }
        });
        titleHeaderListData[action.targetGrid] = updatedSelectedGridData;
      }
      return {
        ...state,
        crosstabTitleHeaderList: titleHeaderListData,
      };
    }

    case types.UPDATE_TOGGLE_LABEL_FLAG: {
      const keyType = action.gridType;
      return {
        ...state,
        toggleCheckValue: {
          ...state.toggleCheckValue,
          [keyType]: !state.toggleCheckValue[keyType],
        },
      };
    }

    case types.UPDATE_COLUMN_CT_SORT: {
      return {
        ...state,
        crosstabColumnSort: {
          direction: action.direction,
          variable: action.variable,
          index: action.index,
        },
      };
    }

    case types.EXPRESSIONS_BREADCRUMBS_LIST: {
      const requestList = action.requestList;
      const breadCrumbsList = action.payload;
      const gridType = {};
      requestList.forEach((elems, index) => {
        gridType[elems.trim()] = breadCrumbsList[index].trim();
      });

      const CrosstabBreadCrumbsList = { ...state.CrosstabBreadCrumbsList };
      CrosstabBreadCrumbsList[action.gridType] = gridType;

      return {
        ...state,
        CrosstabBreadCrumbsList,
      };
    }

    case types.EXPRESSIONS_DETAILS_LIST: {
      const DictionaryDetails = { ...state.DictionaryDetails };
      DictionaryDetails[action.gridType] = action.payload;

      return {
        ...state,
        DictionaryDetails,
      };
    }

    case types.UPDATE_CROSSTAB_GRID_TITLE_HEADER: {
      const crosstabTitleHeaderList = { ...state.crosstabTitleHeaderList };
      const crosstabTableList = cloneDeep(state.crosstabTableList);

      const updatedHeader = crosstabTitleHeaderList[action.payload.gridCategory]
        ? cloneDeep(crosstabTitleHeaderList[action.payload.gridCategory])
        : [];
      if (updatedHeader.length > 0) {
        const matchedItem = updatedHeader.filter(
          item => item.keyword === action.payload.keyword
        );
        if (matchedItem.length > 0) {
          const indexToDelete = updatedHeader.findIndex(
            item => item.keyword === matchedItem[0].keyword
          );
          if (indexToDelete !== -1) {
            if (
              action.payload.updatedTitle !==
              updatedHeader[indexToDelete].originalTitle
            ) {
              updatedHeader.splice(indexToDelete, 1);
              updatedHeader.push({
                index: action.payload.index,
                originalTitle: action.payload.originalTitle,
                updatedTitle: action.payload.updatedTitle,
                keyword: action.payload.keyword,
              });
            } else {
              updatedHeader.splice(indexToDelete, 1);
            }
          }
        } else {
          updatedHeader.push({
            index: action.payload.index,
            originalTitle: action.payload.originalTitle,
            updatedTitle: action.payload.updatedTitle,
            keyword: action.payload.keyword,
          });
        }
      } else {
        updatedHeader.push({
          index: action.payload.index,
          originalTitle: action.payload.originalTitle,
          updatedTitle: action.payload.updatedTitle,
          keyword: action.payload.keyword,
        });
      }
      crosstabTitleHeaderList[action.payload.gridCategory] = updatedHeader;

      if (
        action.payload.gridCategory === 'ColumnsDataGrid' &&
        crosstabTableList &&
        crosstabTableList.length > 0
      ) {
        if (crosstabTableList[0].columnHeaderList[action.payload.index + 1]) {
          crosstabTableList[0].isLabelUpdated = action.payload.isLabelUpdated;
          crosstabTableList[0].columnHeaderList[
            action.payload.index + 1
          ].isColumnLabelUpdated = action.payload.isLabelUpdated;
          crosstabTableList[0].columnHeaderList[
            action.payload.index + 1
          ].label = action.payload.updatedTitle;
          crosstabTableList[0].columnHeaderList[
            action.payload.index + 1
          ].autocodenode.labelOverride = action.payload.updatedTitle;
          crosstabTableList[0].columnHeaderList[
            action.payload.index + 1
          ].autocodenode.useLabelOverride = true;
        }
      } else if (
        action.payload.gridCategory === 'RowsDataGrid' &&
        crosstabTableList &&
        crosstabTableList.length > 0
      ) {
        let isUpdatedFlag = false;
        crosstabTableList[0].crosstabPerStudy[0].map(item => {
          if (item.rowList[action.payload.index + 1]) {
            isUpdatedFlag = true;
            item.rowList[action.payload.index + 1].isRowLabelUpdated =
              action.payload.isLabelUpdated;
            item.rowList[action.payload.index + 1].rowHeader =
              action.payload.updatedTitle;
            item.rowList[action.payload.index + 1].autocodenode.labelOverride =
              action.payload.updatedTitle;
            item.rowList[
              action.payload.index + 1
            ].autocodenode.useLabelOverride = action.payload.isLabelUpdated;
          }
          return item;
        });
        if (isUpdatedFlag) {
          crosstabTableList[0].isLabelUpdated = action.payload.isLabelUpdated;
        }
      }

      return {
        ...state,
        crosstabTitleHeaderList,
        crosstabTableList,
      };
    }
    case types.OPEN_SHARED_CROSSTAB: {
      return {
        ...state,
        openSharedCrossTab: action.payload,
      };
    }

    case types.RESTORE_TITLE_NAME: {
      const keyType = `${action.gridType}Data`;
      const crosstabTableList = cloneDeep(state.crosstabTableList);
      const gridData = cloneDeep(state[keyType]);
      const RowsDataGridData = cloneDeep(state.RowsDataGridData);
      const ColumnsDataGridData = cloneDeep(state.ColumnsDataGridData);
      if (action.gridType === 'RowsDataGrid') {
        let defaultVal;
        crosstabTableList[0].crosstabPerStudy[0].map(item => {
          defaultVal = item.rowList[action.index + 1].tooltipVal;
          item.rowList[action.index + 1].rowHeader = defaultVal;
          item.rowList[action.index + 1].isRowLabelUpdated = false;
          return item;
        });
        gridData[action.index].isLabelUpdated = false;
        gridData[action.index].title = defaultVal;
        gridData[action.index].originalTitle = defaultVal;
      } else {
        const defaultVal =
          crosstabTableList[0].columnHeaderList[action.index + 1].tooltipVal;
        crosstabTableList[0].columnHeaderList[
          action.index + 1
        ].label = defaultVal;
        crosstabTableList[0].columnHeaderList[
          action.index + 1
        ].isColumnLabelUpdated = false;
        crosstabTableList[0].colHeaderList[action.index] = defaultVal;
        gridData[action.index].isLabelUpdated = false;
        gridData[action.index].title = defaultVal;
        gridData[action.index].originalTitle = defaultVal;
      }
      let isLabelUpdatedFlag = false;
      if (action.gridType === 'RowsDataGrid') {
        gridData.forEach((item, index) => {
          if (item.isLabelUpdated) {
            isLabelUpdatedFlag = true;
          }
          if (
            index === action.index &&
            item.dataSmartSearch &&
            item.dataSmartSearch.autocodenode &&
            item.dataSmartSearch.autocodenode.useLabelOverride &&
            !isEmpty(item.dataSmartSearch.autocodenode.data)
          ) {
            item.dataSmartSearch.autocodenode.useLabelOverride = false;
            item.dataSmartSearch.autocodenode.labelOverride = '';
          }
        });
        ColumnsDataGridData.forEach(item => {
          if (item.isLabelUpdated) {
            isLabelUpdatedFlag = true;
          }
        });

        crosstabTableList[0].crosstabPerStudy[0].map(item => {
          const autocodenode = cloneDeep(
            item.rowList[action.index + 1].autocodenode
          );
          if (
            autocodenode.type === 'dictionary' &&
            isEmpty(autocodenode.data)
          ) {
            item.rowList[action.index + 1].autocodenode.useLabelOverride =
              autocodenode.useLabelOverride;
            item.rowList[action.index + 1].autocodenode.labelOverride =
              autocodenode.labelOverride;
          } else {
            item.rowList[
              action.index + 1
            ].autocodenode.useLabelOverride = false;
            item.rowList[action.index + 1].autocodenode.labelOverride = '';
          }
          return item;
        });
      } else {
        gridData.forEach((item, index) => {
          if (item.isLabelUpdated) {
            isLabelUpdatedFlag = true;
          }
          if (
            index === action.index &&
            item.dataSmartSearch &&
            item.dataSmartSearch.autocodenode &&
            item.dataSmartSearch.autocodenode.useLabelOverride &&
            !isEmpty(item.dataSmartSearch.autocodenode.data)
          ) {
            item.dataSmartSearch.autocodenode.useLabelOverride = false;
            item.dataSmartSearch.autocodenode.labelOverride = '';
          }
        });
        RowsDataGridData.forEach(item => {
          if (item.isLabelUpdated) {
            isLabelUpdatedFlag = true;
          }
        });

        const autocodenode = cloneDeep(
          crosstabTableList[0].columnHeaderList[action.index + 1].autocodenode
        );
        if (autocodenode.type === 'dictionary' && isEmpty(autocodenode.data)) {
          crosstabTableList[0].columnHeaderList[
            action.index + 1
          ].autocodenode.useLabelOverride = autocodenode.useLabelOverride;
          crosstabTableList[0].columnHeaderList[
            action.index + 1
          ].autocodenode.labelOverride = autocodenode.labelOverride;
        } else {
          crosstabTableList[0].columnHeaderList[
            action.index + 1
          ].autocodenode.useLabelOverride = false;
          crosstabTableList[0].columnHeaderList[
            action.index + 1
          ].autocodenode.labelOverride = '';
        }
      }
      crosstabTableList[0].isLabelUpdated = isLabelUpdatedFlag;
      return {
        ...state,
        [keyType]: gridData,
        crosstabTableList,
        // crosstabTitleHeaderList,
      };
    }

    case types.GET_FUNCTION_LIST_FOR_PROBABILITIES: {
      return {
        ...state,
        probabilityFunctionList: [...PROBABILTIES_FUNCTIONS],
      };
    }

    case types.SET_SELECTED_LABEL_AC: {
      return {
        ...state,
        partsToShow: action.labelConfig,
      };
    }

    case types.SET_DICTIONARY_USE_QUESTIONS: {
      const partsToShow = {
        showCat: false,
        showSCats: false,
        showQ: true,
        showA: true,
      };
      if (!action.payload) {
        partsToShow.showQ = false;
      }
      return {
        ...state,
        partsToShow,
        useQuestions: action.payload,
      };
    }

    case types.GET_AUTOCODE_SAMPLE_WEIGHTED: {
      // Required Parameters: payload, targetGrid, expressionList, selectedNames
      // Optional Parameters: sourceGrid, gridData, titlePrefix, originalNames
      const keyType = `${action.targetGrid}Data`;
      // const crosstabTableList = cloneDeep(state.crosstabTableList);
      let gridData = [];
      const userDefinedText = action.userDefinedText;
      const oldProductNo = action.oldProductNo && action.oldProductNo;
      if (
        action.gridData ||
        (oldProductNo && oldProductNo !== action.productNo)
      ) {
        gridData = action.gridData ? action.gridData : [];
      } else if (state[keyType]) {
        gridData = state[keyType];
      }
      const titlePrefix = action.titlePrefix ? action.titlePrefix : '';
      const selectedKPIsTitle = { ...state.selectedKPIsTitle };

      const savedKPIs = { ...state.allSelectedKPIsInfo };
      const sampleWeightedKPIs = { ...state.sampleWeightedKPIs };
      action.expressionList.forEach((item, index) => {
        savedKPIs[item] = {
          modeled: action.payload[index]
            ? action.payload[index].modeled
            : false,
          productNo: action.productNo,
        };
        sampleWeightedKPIs[item] = {
          productNo: action.productNo,
          data: action.payload[index] ? [action.payload[index]] : [],
        };
      });
      const draggedItems = [];
      action.payload.forEach((selectedEntry, index) => {
        let title = '';
        const isLabelUpdated = action.isLabelUpdated
          ? action.isLabelUpdated[index]
          : undefined;
        if (
          action.sourceGrid !== 'FunctionBox' &&
          action.targetGrid !== 'FunctionBoxCountDataGrid'
        ) {
          title = `${titlePrefix.toUpperCase()}${action.selectedNames[
            index
          ].toUpperCase()}`;
        }
        if (action.targetGrid === 'FunctionBoxCountDataGrid') {
          title = titlePrefix
            ? `${titlePrefix.toUpperCase()}${action.selectedNames[
                index
              ].toUpperCase()}`
            : '';
        }
        if (action.sourceGrid === 'FunctionBox') {
          title = action.selectedNames[index].toUpperCase();
        }
        let originalTitle = title;
        const rectype = action.recTypes && action.recTypes[index];
        selectedKPIsTitle[action.expressionList[index]] = title;
        if (action.originalNames && action.originalNames.length > 0) {
          originalTitle = action.originalNames[index];
        } else if (
          action.sourceGrid !== 'ColumnsDataGrid' &&
          action.sourceGrid !== 'RowsDataGrid' &&
          action.sourceGrid !== 'BasesDataGrid' &&
          action.sourceGrid !== 'ScratchDataGrid' &&
          action.sourceGrid !== 'ExpressionCodingBox' &&
          action.sourceGrid !== 'StandardBasesDataGrid' &&
          action.sourceGrid !== 'FunctionBox' &&
          action.sourceGrid !== 'AutocodeSelectionBox'
        ) {
          originalTitle = CrosstabUtils.DEFAULT_GRID_CELL_LABEL;
        }
        const weighted =
          selectedEntry && selectedEntry.weighted
            ? roundWeighted(selectedEntry.weighted)
            : '';
        const updatedWeighted =
          action.targetGrid === 'FunctionBoxCommonDataGrid' ||
          action.targetGrid === 'FunctionBoxCountDataGrid'
            ? CrosstabUtils.smartRoundOff(weighted * 1000)
            : roundWeighted(weighted);

        if (keyType === 'StandardBasesDataGridData') {
          draggedItems.push({
            id: uuid(),
            sample:
              selectedEntry && selectedEntry.intab ? selectedEntry.intab : '',
            keyword: action.expressionList[index],
            weighted: updatedWeighted === 0 ? '' : updatedWeighted,
            title,
            originalTitle,
            rectype,
            dataSmartSearch: action.objSmartSearchArray
              ? action.objSmartSearchArray[index]
              : undefined,
          });
        } else {
          let dataSmartSearch = [];
          if (
            action.sourceGrid === 'ColumnsDataGrid' &&
            !(action.objSmartSearchArray && action.objSmartSearchArray[index])
          ) {
            dataSmartSearch = CrosstabUtils.createDataSmartSearch(
              state.CrosstabBreadCrumbsList,
              state.DictionaryDetails,
              action.expressionList[index],
              originalTitle,
              'ColumnsGrid'
            );
          } else if (
            action.sourceGrid === 'RowsDataGrid' &&
            !(action.objSmartSearchArray && action.objSmartSearchArray[index])
          ) {
            dataSmartSearch = CrosstabUtils.createDataSmartSearch(
              state.CrosstabBreadCrumbsList,
              state.DictionaryDetails,
              action.expressionList[index],
              originalTitle,
              'RowsGrid'
            );
          }
          draggedItems.push({
            id: uuid(),
            sample:
              selectedEntry && selectedEntry.intab ? selectedEntry.intab : '',
            keyword: action.expressionList[index],
            weighted: updatedWeighted === 0 ? '' : updatedWeighted,
            title,
            originalTitle,
            rectype,
            userDefinedText,
            dataSmartSearch:
              action.objSmartSearchArray && action.objSmartSearchArray[index]
                ? action.objSmartSearchArray[index]
                : dataSmartSearch,
            isLabelUpdated,
          });
        }
      });
      let finalData = [];
      if (keyType === 'StandardBasesDataGridData' || action.weightChange) {
        finalData = [...draggedItems];
      } else {
        finalData = [...gridData, ...draggedItems];
      }
      return {
        ...state,
        selectedKPIsTitle,
        [keyType]: finalData,
        allSelectedKPIsInfo: savedKPIs,
        sampleWeightedKPIs,
      };
    }

    case types.LOAD_NEWSPC_SAVED_CROSSTAB: {
      const payloadData = cloneDeep(action.payload);

      const isColLabelUpdated = [];
      const isRowLabelUpdated = [];

      const RowsDataGrid = [];
      const ColumnsDataGrid = [];

      payloadData.labelDetails.rows.forEach(
        ({ index, isLabelUpdated, keyword, updatedTitle, originalTitle }) => {
          isRowLabelUpdated.push(isLabelUpdated);
          RowsDataGrid.push({
            index,
            keyword,
            updatedTitle,
            originalTitle,
          });
        }
      );

      payloadData.labelDetails.columns.forEach(
        ({ index, isLabelUpdated, keyword, updatedTitle, originalTitle }) => {
          isColLabelUpdated.push(isLabelUpdated);
          ColumnsDataGrid.push({
            index,
            keyword,
            updatedTitle,
            originalTitle,
          });
        }
      );
      payloadData.isColLabelUpdated = isColLabelUpdated;
      payloadData.isRowLabelUpdated = isRowLabelUpdated;

      // console.log('payloadData:', payloadData);
      return {
        ...state,
        savedNewSPCCrosstabData: payloadData,
        loadedCrosstabInfo: {
          id: action.payload.id,
          title: payloadData.title,
          tableTitle:
            state.crosstabTableList && state.crosstabTableList.length > 0
              ? state.loadedCrosstabInfo.tableTitle
              : payloadData.title,
          isDuplicateCrossTabTitle: false,
          chartType: action.payload.attributes
            ? action.payload.attributes.chartType
            : undefined,
        },
        crosstabTitleHeaderList: {
          RowsDataGrid,
          ColumnsDataGrid,
        },
        BasesDataGridData: [],
        RowsDataGridData: [],
        ColumnsDataGridData: [],
      };
    }

    case types.SHOW_NEWSPC_VALIDATE_RESPONSE: {
      if (action.trendMultipleProducts) {
        return {
          ...state,
          newSpcGridValidationResponse: {
            trendProducts: [...action.payload],
            baseOriginalHeaderList: action.baseOriginalHeaderList,
            colOriginalHeaderList: action.colOriginalHeaderList,
            rowOriginalHeaderList: action.rowOriginalHeaderList,
            isColLabelUpdated: action.isColLabelUpdated,
            isRowLabelUpdated: action.isRowLabelUpdated,
            newSpcParams: action.newSpcParams,
          },
        };
      }
      return {
        ...state,
        newSpcGridValidationResponse: {
          ...action.payload,
          baseOriginalHeaderList: action.baseOriginalHeaderList,
          colOriginalHeaderList: action.colOriginalHeaderList,
          rowOriginalHeaderList: action.rowOriginalHeaderList,
          oldProductNo: action.oldProductNo,
          isColLabelUpdated: action.isColLabelUpdated,
          isRowLabelUpdated: action.isRowLabelUpdated,
          newSpcParams: action.newSpcParams,
        },
      };
    }

    case types.UPDATE_NEWSPC_SAVED_CROSSTAB_DATA: {
      const payloadData = cloneDeep(action.payload);
      _.unset(payloadData, 'baseHeaderList');
      _.unset(payloadData, 'baseList');
      _.unset(payloadData, 'colExpressionList');
      _.unset(payloadData, 'colHeaderList');
      _.unset(payloadData, 'rowExpressionList');
      _.unset(payloadData, 'rowHeaderList');
      _.unset(payloadData, 'warningType');

      return {
        ...state,
        loadNewSPCCrosstabData: payloadData,
      };
    }

    default:
      return state;
  }
};
